// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2vB3x","list":"styles_list__324md"};